import React, { useState } from 'react';
import { ErrorMesg, ErrorMessage, KeywordWrapper, Label, SubLabel } from '../TopicBuilder/MainContent/QueryBuilder/TopicBuilder.styled';
import { AddIconDiv, FlexRowDiv, LogoDiv, MainWrapper, RadioBtnDiv, RadioDiv, RecentlyCreated, ScrollableDiv, SearchContainer, SearchIcon, SearchInput, SearchMainDiv, SearchTopicsHeading, TextDivTopic, TextMainDiv } from './SelectChannelPage.style';
import { DownArrowIcon, FacebookIcon, FacebookLogo, FlipkartIconSmall, FlipkartLogo, InstagramIconSmall, InstagramLogo, StyledAddIcon2, X_LOGO, YouTubeRedIcon } from '../../Common/SvgIcon/CommonSvgIcons';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Lottie from 'lottie-react';
import Loader from '../../assests/animation/Loader2.json';
import { useNavigate, useNavigation } from 'react-router-dom';
import styled from 'styled-components';
const NoDataWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 20% 1fr min-content;
  gap: 2%;
  padding-top: 5px;
  box-sizing: border-box;

  width: 100%;
  color: #2A2929;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PrimaryTopicComponent = ({
    RecentlyCreatedVal = "",
    PlaceHolderVal,
    expandPrimary,
    mainLabelVal = '',
    subLabelVal = '',
    setExpandPrimary,
    topicOptions = [],
    handleSelect,
    type = "",
    channelType,
    topicTitle = "",
    value = '',
    onChangeSearch,
    seachTopic = [],
    secondaryCiList,
    searchLoader = false,
    isSecondary = false,
    checked,
    setChecked,
    topicError
}) => {
  const navigate = useNavigate();

  const renderLogo = (channel) => {
    if (channel === 'facebook') return FacebookLogo;
    if (channel === 'instagram') return InstagramLogo;
    if (channel === 'twitter') return X_LOGO;
    if (channel === 'flipkart') return FlipkartIconSmall;
    if (channel === 'youtube') return YouTubeRedIcon;
    return null;
  };

  return (
    <div>
      <KeywordWrapper>
        <Label>{mainLabelVal} <span>*</span></Label>
        <br />
        <SubLabel>{subLabelVal}</SubLabel>
      </KeywordWrapper>

      {expandPrimary ? (
        <MainWrapper>
          <FlexRowDiv
            data-testid="collapse-button"
            onClick={() => setExpandPrimary(false)}
          >
            <SearchTopicsHeading>{PlaceHolderVal}</SearchTopicsHeading>
            <div><KeyboardArrowUpIcon /></div>
          </FlexRowDiv>

          {!isSecondary ? (
            <>
              <SearchMainDiv>
                <div>
                  <SearchContainer>
                    <SearchInput
                      data-testid="search-input"
                      type="text"
                      placeholder="Search..."
                      value={value}
                      onChange={(e) => onChangeSearch(e.target.value)}
                    />
                    <SearchIcon />
                  </SearchContainer>
                </div>
                <AddIconDiv
                  
                  onClick={() =>
                    navigate(channelType === 'Social Topics' ? '/topic/create' : '/chatter/home')
                  }
                >
                  {StyledAddIcon2}
                </AddIconDiv>
              </SearchMainDiv>

              {searchLoader ? (
                <div style={{ width: '130px', margin: '0 auto' }}>
                  <div data-testid="lottie-loader">
                    <Lottie animationData={Loader} loop />
                  </div>
                </div>
              ) : seachTopic.length > 0 ? (
                <ScrollableDiv>
                  {seachTopic.map((val, index) => (
                    <TextDivTopic
                      key={index}
                      data-testid={`search-topic-${index}`}
                      onClick={() => handleSelect({ val, type })}
                    >
                      <LogoDiv channel={val.channel === 'flipkart'}>
                        {renderLogo(val.channel)}
                      </LogoDiv>
                      <p title={val.title || val.chatter_title}>{val.title || val.chatter_title}</p>
                    </TextDivTopic>
                  ))}
                </ScrollableDiv>
              ) : (
                <NoDataWrapper>No Results Found</NoDataWrapper>
              )}

              <RecentlyCreated>{RecentlyCreatedVal}</RecentlyCreated>
              <TextMainDiv>
                {topicOptions.slice(0, 3).map((val, index) => (
                  <TextDivTopic
                    key={index}
                    data-testid={`suggested-topic-${index}`}
                    onClick={() => handleSelect({ val, type })}
                  >
                    <LogoDiv channel={val.channel === 'flipkart'}>
                      {renderLogo(val.channel)}
                    </LogoDiv>
                    <p title={val.title || val.chatter_title}>{val.title || val.chatter_title}</p>
                  </TextDivTopic>
                ))}
              </TextMainDiv>
            </>
          ) : (
            <>
              <RadioBtnDiv>
                <RadioDiv>
                  <input
                    type="radio"
                    id="shared"
                    checked={checked}
                    onClick={() => setChecked(true)}
                    data-testid="shared-radio"
                  />
                  <span onClick={() => setChecked(true)}></span>
                  <span>Shared Intervals</span>
                </RadioDiv>
                <RadioDiv>
                  <input
                    type="radio"
                    id="different"
                    checked={!checked}
                    onClick={() => setChecked(false)}
                    data-testid="different-radio"
                  />
                  <span onClick={() => setChecked(false)}></span>
                  <>Different Intervals</>
                </RadioDiv>
              </RadioBtnDiv>

              <RecentlyCreated>{RecentlyCreatedVal}</RecentlyCreated>
              <ScrollableDiv>
                {(checked
                  ? secondaryCiList?.shared_interval_list
                  : secondaryCiList?.different_interval_list
                )?.map((val, index) => (
                  <TextDivTopic
                    key={index}
                    data-testid={`secondary-topic-${index}`}
                    onClick={() => handleSelect({ val, type })}
                  >
                    <LogoDiv channel={val.channel === 'flipkart'}>
                      {renderLogo(val.channel)}
                    </LogoDiv>
                    <p title={val.title || val.chatter_title}>{val.title || val.chatter_title}</p>
                  </TextDivTopic>
                ))}
              </ScrollableDiv>
            </>
          )}
        </MainWrapper>
      ) : (
        <MainWrapper data-testid="expand-button" onClick={() => setExpandPrimary(true)}>
          <FlexRowDiv>
            <SearchTopicsHeading color={true}>
              {topicTitle || PlaceHolderVal}
            </SearchTopicsHeading>
            <div><KeyboardArrowDownIcon /></div>
          </FlexRowDiv>
        </MainWrapper>
      )}

      {topicError && (
        <ErrorMessage style={{ marginTop: '5px' }}>
          Select Any One Topic
        </ErrorMessage>
      )}
    </div>
  );
};

export default PrimaryTopicComponent;
